import { Component } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { NgForm } from '@angular/forms';
import { InvoiceApi } from '@app/services/invoice-api';
import {
  PaginatedResponse,
  RecursiveInterface,
} from '@app/services/base-authenticated.service';
import {
  DocumentTypeOptions,
  InvoiceInterface,
  PensionFundOptions,
} from '@app/interface/invoice';
import { MatTableDataSource } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { CompanyApi } from '@app/services/company-api';
import { CompanyInterface } from '@app/interface/company';
import { Observable } from 'rxjs';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
// import {AsyncPipe} from '@angular/common';
import { map, startWith } from 'rxjs/operators';
// import { OnInit } from '@angular/core';
import { CompanyAutocompleteComponent } from '@app/company-autocomplete/company-autocomplete';
import { CurrencyOption } from '@app/interface/currency-options';
import { PaymentMethodOptions } from '@app/interface/payment-method-options';
// import { LayoutComponent } from '@app/layout/layout.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { IvaCollectabilityOptions } from '@app/interface/iva-collectability-options';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ChangeDetectionStrategy, inject, model, signal } from '@angular/core';
import { NewCompanyDialog } from '@app/new-company/new-company.component';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { LanguageOptions } from '@app/interface/language-options';
import { StatusOptions } from '@app/interface/status-options';
import { Input, EventEmitter, Output } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { ProductServiceInterface } from '@app/interface/product-service';
import { AtecoCodeInterface } from '@app/interface/ateco-code';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ArubaService } from '@app/services/aruba.service';
import { MatStepperModule } from '@angular/material/stepper';
import { SavedproductAutocompleteComponent } from '@app/savedproduct-autocomplete/savedproduct-autocomplete.component';
import { SavedProductInterface } from '@app/interface/savedproduct';
import * as moment from 'moment';
import { format, parseISO, addDays, differenceInCalendarDays } from 'date-fns';
import { ConfirmInvoiceDialogComponent } from '@app/confirm-invoice-dialog/confirm-invoice-dialog.component';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { LoadingDialogComponent } from '@app/loading-dialog/loading-dialog.component';
import { ChangeDetectorRef } from '@angular/core';
import { forkJoin } from 'rxjs';
import { ProductserviceApiService } from '@app/services/productservice-api.service';
import { AtecoCodeApiService } from '@app/services/ateco-code-api.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {
  TaxWithholdingInterface,
  KindOptions,
  KindCode,
} from '@app/interface/tax-withholding';
import { TaxWithholdingApi } from '@app/services/tax-withholding-api.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { PreventiveInterface } from '@app/interface/preventive';
import { DownloadConfirmationDialogComponent } from '@app/download-confirmation-dialog/download-confirmation-dialog.component';
import { OrganizationApi } from '@app/services/organization-api.service';
import { ConfirmInvoiceDuplicateComponent } from '@app/confirm-duplicate-dialog/confirm-duplicate-dialog.component';
import { ConfirmEmailSendDialogComponent } from '@app/confirm-email-send-dialog/confirm-email-send-dialog.component';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { BackHeaderComponent } from '@app/back-header/back-header.component';
import { ConfirmInvoiceDraftSaveComponent } from '@app/confirm-invoice-draft-save/confirm-invoice-draft-save.component';
import { ConfirmInvoiceCompanyDataDialogComponent } from '@app/confirm-invoice-company-data-dialog/confirm-invoice-company-data-dialog.component';
import { CanComponentDeactivate } from '@app/_guards/can-deactivate.guard';
import { HostListener } from '@angular/core';
import { ConfirmDateDialogComponent } from '@app/confirm-date-dialog-component/confirm-date-dialog-component.component';
import { Organizations } from '@app/interface/organizations';
import { SavedProductsApi } from '@app/services/savedproducts-api.service';
import { ConfirmInvoiceDeleteComponent } from '@app/confirm-delete-dialog/confirm-delete-dialog.component';
import { PdfViewerDialogComponent } from '@app/pdf-viewer-dialog/pdf-viewer-dialog.component';
import { Guide2DetailsDialogComponent } from '@app/guide-details-dialog/guide-details-dialog.component';
import { TextFieldModule } from '@angular/cdk/text-field';
import {
  InvoiceDuplicateDraft,
  QuickInvoiceDraft,
  QuickInvoiceTransferService,
} from '@app/services/quick-invoice-transfer.service';

@Component({
  selector: 'izy-new-invoice',
  templateUrl: './new-invoice.component.html',
  styleUrl: './new-invoice.component.scss',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSnackBarModule,
    MatSelectModule,
    MatAutocompleteModule,
    // AsyncPipe,
    CompanyAutocompleteComponent,
    // LayoutComponent,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    MatCardModule,
    MatIconModule,
    MatDividerModule,
    MatTooltipModule,
    MatStepperModule,
    SavedproductAutocompleteComponent,
    // ConfirmInvoiceDialogComponent,
    MatProgressSpinnerModule,
    MatExpansionModule,
    BackHeaderComponent,
    TextFieldModule,
  ],
  providers: [
    InvoiceApi,
    MatSnackBar,
    CompanyApi,
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: 'DD/MM/YYYY',
        },
        display: {
          dateInput: 'DD/MM/YYYY',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
        },
        provide: MAT_DATE_LOCALE,
        useValue: 'it-IT',
      },
    },
  ],
  standalone: true,
})
export class NewInvoiceComponent implements CanComponentDeactivate {
  @ViewChild('productsList') productsListElement!: ElementRef;
  @ViewChild('companyAutocomplete')
  companyAutocomplete!: CompanyAutocompleteComponent;

  // Track if form has unsaved changes
  hasUnsavedChanges = false;

  // dict:
  currencyOptions: CurrencyOption[] = [
    { code: 'USD', name: 'US Dollar' },
    { code: 'EUR', name: 'Euro' },
    { code: 'GBP', name: 'British Pound' },
    { code: 'JPY', name: 'Japanese Yen' },
    { code: 'CAD', name: 'Canadian Dollar' },
    { code: 'AUD', name: 'Australian Dollar' },
    { code: 'CNY', name: 'Chinese Yuan' },
    { code: 'INR', name: 'Indian Rupee' },
  ];

  paymentMethodOptions: PaymentMethodOptions[] = [
    { code: 'MP01', name: 'Contanti' },
    { code: 'MP02', name: 'Assegno' },
    { code: 'MP03', name: 'Assegno circolare' },
    { code: 'MP04', name: 'Contanti presso Tesoreria' },
    { code: 'MP05', name: 'Bonifico' },
    { code: 'MP06', name: 'Vaglia cambiario' },
    { code: 'MP07', name: 'Bollettino bancario' },
    { code: 'MP08', name: 'Carta di credito' },
    { code: 'MP09', name: 'RID' },
    { code: 'MP10', name: 'RID utenze' },
    { code: 'MP11', name: 'RID veloce' },
    { code: 'MP12', name: 'Riba' },
    { code: 'MP13', name: 'MAV' },
    { code: 'MP14', name: 'Quietanza erario stato' },
    { code: 'MP15', name: 'Giroconto su conti di contabilità speciale' },
    { code: 'MP16', name: 'Domiciliazione bancaria' },
    { code: 'MP17', name: 'Domiciliazione postale' },
  ];

  pensionFundOptions: PensionFundOptions[] = [
    {
      code: 'TC01',
      name: 'Cassa nazionale previdenza e assistenza avvocati e procuratori legali',
    },
    { code: 'TC02', name: 'Cassa previdenza dottori commercialisti' },
    { code: 'TC03', name: 'Cassa previdenza e assistenza geometri' },
    {
      code: 'TC04',
      name: 'Cassa nazionale previdenza e assistenza ingegneri e architetti liberi professionisti',
    },
    { code: 'TC05', name: 'Cassa nazionale del notariato' },
    {
      code: 'TC06',
      name: 'Cassa nazionale previdenza e assistenza ragionieri e periti commerciali',
    },
    {
      code: 'TC07',
      name: 'Ente nazionale assistenza agenti e rappresentanti di commercio (ENASARCO)',
    },
    {
      code: 'TC08',
      name: 'Ente nazionale previdenza e assistenza consulenti del lavoro (ENPACL)',
    },
    {
      code: 'TC09',
      name: 'Ente nazionale previdenza e assistenza medici (ENPAM)',
    },
    {
      code: 'TC10',
      name: 'Ente nazionale previdenza e assistenza farmacisti (ENPAF)',
    },
    {
      code: 'TC11',
      name: 'Ente nazionale previdenza e assistenza veterinari (ENPAV)',
    },
    {
      code: 'TC12',
      name: "Ente nazionale previdenza e assistenza impiegati dell'agricoltura (ENPAIA)",
    },
    {
      code: 'TC13',
      name: 'Fondo previdenza impiegati imprese di spedizione e agenzie marittime',
    },
    {
      code: 'TC14',
      name: 'Istituto nazionale previdenza giornalisti italiani (INPGI)',
    },
    {
      code: 'TC15',
      name: 'Opera nazionale assistenza orfani sanitari italiani (ONAOSI)',
    },
    {
      code: 'TC16',
      name: 'Cassa autonoma assistenza integrativa giornalisti italiani (CASAGIT)',
    },
    {
      code: 'TC17',
      name: 'Ente previdenza periti industriali e periti industriali laureati (EPPI)',
    },
    {
      code: 'TC18',
      name: 'Ente previdenza e assistenza pluricategoriale (EPAP)',
    },
    {
      code: 'TC19',
      name: 'Ente nazionale previdenza e assistenza biologi (ENPAB)',
    },
    {
      code: 'TC20',
      name: 'Ente nazionale previdenza e assistenza professione infermieristica (ENPAPI)',
    },
    {
      code: 'TC21',
      name: 'Ente nazionale previdenza e assistenza psicologi (ENPAP)',
    },
    { code: 'TC22', name: 'INPS' },
  ];

  ivaCollectabilityOptions: IvaCollectabilityOptions[] = [
    { code: 'IMMEDIATA', name: 'Immediata' },
    { code: 'DIFFERITA', name: 'Differita' },
    { code: 'SPLIT', name: 'Split payment' },
  ];

  languageOptions: LanguageOptions[] = [
    { code: 'it', name: 'Italiano' },
    { code: 'en', name: 'Inglese' },
    { code: 'fr', name: 'Francese' },
    { code: 'de', name: 'Tedesco' },
    { code: 'es', name: 'Spagnolo' },
  ];

  statusOptions: StatusOptions[] = [
    { code: 'TRASMESSA', name: 'Trasmessa' },
    { code: 'ATTESA', name: 'Atttesa' },
  ];

  documentTypeOptions: DocumentTypeOptions[] = [
    { code: 'TD01', name: 'Fattura' },
    { code: 'TD04', name: 'Nota di credito' },
  ];

  kindOptions: KindOptions[] = [
    { code: 'CASSA', name: 'Cassa previdenziale' },
    { code: 'RIVALSA', name: 'Rivalsa INPS' },
    { code: 'RITENUTA', name: 'Ritenuta' },
    // { code: 'RITENUTA_ACCONTO', name: "Ritenuta d'acconto" },
  ];

  // export type KindCode = 'CASSA' | 'RIVALSA' | 'RITENUTA';

  atecoCodes: AtecoCodeInterface[] = [];
  // selectedAtecoCode: number | null = null; // To store the selected ATECO code ID
  taxWithholdings: Partial<TaxWithholdingInterface>[] = [];

  // IBAN validation
  isValidIban: boolean = true;
  ibanPattern: RegExp = /^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{11,30}$/;

  validateIban(): void {
    if (this.newInvoice.iban) {
      this.isValidIban = this.ibanPattern.test(this.newInvoice.iban);
    } else {
      this.isValidIban = true; // or false if IBAN is required
    }
  }

  // product description validation
  latinPattern = /^[\p{Script=Latin}\p{N}\p{P}\p{S}\p{Z}]{1,1000}$/u;
  nameError: string = '';
  readonly MAX_DESCRIPTION_LENGTH = 1000;

  validateProductDescription(name: string | undefined): void {
    if (!this.newProductService.name) {
      this.nameError = 'La descrizione è obbligatoria';
      return;
    }

    if (!this.latinPattern.test(name || '')) {
      this.nameError =
        'Sono ammessi solo caratteri latini (lettere, numeri, simboli standard e caratteri accentati)';
    } else if (this.newProductService.name.length > 1000) {
      this.nameError = 'La descrizione non può superare 1000 caratteri';
    } else {
      this.nameError = '';
    }
  }

  showDelay = new FormControl(200);
  hideDelay = new FormControl(1000);

  organization_data: Organizations | null = null;

  // to display
  invoice_gross_amount: number = 0;
  invoice_discount_amount: number = 0;
  invoice_discount: number = 0;
  invoice_total_amount: number = 0;
  invoice_iva_amount: number = 0;
  numero_articoli: number = 0;
  numero_contributi: number = 0;
  invoice_revenue_stamp: number = 0;
  invoice_revenue_stamp_on_user: boolean = false;

  // totals
  gross_amount: number = 0;
  total_amount: number = 0.0;
  iva_amount: number = 0.0;
  discount_amount: number = 0;
  discount: number = 0;

  // these properties to store intermediate calculation results
  invoice_total_amount_with_rivalsa: number = 0;
  total_taxable: number = 0;
  invoice_total_paid_amount_with_acconto: number = 0;
  invoice_total_paid_amount: number = 0;

  // For display purposes
  rivalsa_total: number = 0;
  rivalsa_rate: number = 0;
  cassa_total: number = 0;
  cassa_rate: number = 0;
  ritenuta_acconto_total: number = 0;
  ritenuta_acconto_rate: number = 0;
  ritenuta_total: number = 0;
  ritenuta_rate: number = 0;

  newInvoice: Partial<InvoiceInterface> = {
    invoice_name: '',
    // emission_date: moment().format('YYYY-MM-DD'), // Default: today's date in YYYY-MM-DD
    // payment_date: moment().format('YYYY-MM-DD'), // Default: today's date in YYYY-MM-DD
    emission_date: format(new Date(), 'yyyy-MM-dd'), // Today's date
    payment_date: format(new Date(), 'yyyy-MM-dd'), // Today's date
    progressive_number: 1,
    enumeration: format(new Date(), 'yyyy'), // current year
    transmission_format: 'FPR12',
    description: '',
    description_internal: '',
    articles_number: 1,
    amount: 0,
    gross_amount: 0,
    iva_percentage: 0, // FIXME: real percentage
    iva_amount: 0,
    discount_amount: 0,
    discount: 0,
    addressee_code: '0000000',
    addressee_name: '',
    is_paid: false, // default to false
    language: 'it',
    currency: 'EUR',
    p_a: false,
    payment_method: 'MP05',
    iban: '',
    status: 'ATTESA',
    revenue_stamp: 0,
    revenue_stamp_for_company: false,
    iva_collectability: 'IMMEDIATA',
    // emitted_after,
    revenge: 0,
    pension_fund: 0,
    taxable_amount: 0,
    withholding_advance_tax: 0,
    withholding_tax: 0,
    pension_fund_type: 'TC22',
    healthcare_invoice: false,
    paper_invoice: false,
    document_type: 'TD01',

    document_id: '',
    id_document_date: '',
    id_document_voice: '',
    cod_comm_conv: '',
    cig: '',
    cup: '',
    rif_righe_fatt: '',

    notes: '',

    is_draft: true,
    is_saved_for_preview: false,

    payment_days: 0, // only to compute payment date
    // revenue_stamp_for_user: false, // only to compute revenue stamp without adding it

    ateco_code_id: 0,

    // organization: {
    //   name: '',
    //   is_healthcare: false,
    // },
    organization_id: 1,
    company: {
      company_name: '',
      id: 1,
      iva_number: '',
      address: '',
      addressee_code: '',
      c_f: '',
      email_address: '',
    },
    company_id: 0, // to avoid not authorized invoices
  };

  newProductService: Partial<ProductServiceInterface> = {
    id: 1,
    invoice_id: 1,

    name: '',
    quantity: 1,
    units: '',
    gross_amount: 0,
    discount: 0,
    discount_amount: 0,
    amount: 0,
    description: '',
    iva_percentage: 0,
    iva_amount: 0,
    final_amount: 0,
  };

  // new tax withholding object
  newTaxWithholding: Partial<TaxWithholdingInterface> = {
    kind: 'RIVALSA',
    rate_percentage: 0,
    total_percentage: 100,
    rate_amount: 0,
    total_amount: 0,
    details: '',
  };

  // Keep track of initial values for comparison
  private initialInvoiceState: Partial<InvoiceInterface>;
  private initialProductState: Partial<ProductServiceInterface>;
  private initialTaxState: Partial<TaxWithholdingInterface>;

  constructor(
    private snackBar: MatSnackBar,
    private invoiceService: InvoiceApi,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private arubaService: ArubaService,
    private dateAdapter: DateAdapter<Date>,
    private cdr: ChangeDetectorRef,
    private productServiceApi: ProductserviceApiService,
    private SavedProductApi: SavedProductsApi,
    private AtecoCodesApi: AtecoCodeApiService,
    private taxWithholdingApi: TaxWithholdingApi,
    private organizationService: OrganizationApi,
    private quickInvoiceTransferService: QuickInvoiceTransferService,
  ) {
    this.dateAdapter.setLocale('it-IT');
    // Save initial states
    this.initialInvoiceState = { ...this.newInvoice };
    this.initialProductState = { ...this.newProductService };
    this.initialTaxState = { ...this.newTaxWithholding };

    // Set up periodic checking for changes
    this.setupChangeDetection();
  }

  // Method 1: Periodic checking (simple approach)
  private setupChangeDetection(): void {
    // Check for changes every 500ms
    setInterval(() => {
      this.checkForChanges();
    }, 500);

    // Also check when user interacts with the page
    window.addEventListener('input', () => this.checkForChanges());
    window.addEventListener('change', () => this.checkForChanges());
  }

  markAsChanged(): void {
    this.hasUnsavedChanges = true;
  }

  updateInvoiceField(field: keyof InvoiceInterface, value: any): void {
    this.newInvoice[field] = value;
    this.markAsChanged();
  }

  updateProductField(field: keyof ProductServiceInterface, value: any): void {
    this.newProductService[field] = value;
    this.markAsChanged();
  }

  updateTaxField(field: keyof TaxWithholdingInterface, value: any): void {
    this.newTaxWithholding[field] = value;
    this.markAsChanged();
  }

  private checkForChanges(): void {
    const invoiceChanged = this.hasObjectChanged(
      this.newInvoice,
      this.initialInvoiceState,
    );
    const productChanged = this.hasObjectChanged(
      this.newProductService,
      this.initialProductState,
    );
    const taxChanged = this.hasObjectChanged(
      this.newTaxWithholding,
      this.initialTaxState,
    );

    this.hasUnsavedChanges = invoiceChanged || productChanged || taxChanged;
  }

  private hasObjectChanged(current: any, initial: any): boolean {
    // Simple deep comparison for key properties
    const keys = Object.keys(initial);
    return keys.some((key) => {
      const currentVal = current[key];
      const initialVal = initial[key];

      // Handle dates and nested objects
      if (currentVal instanceof Date && initialVal instanceof Date) {
        return currentVal.getTime() !== initialVal.getTime();
      }

      if (typeof currentVal === 'object' && typeof initialVal === 'object') {
        return JSON.stringify(currentVal) !== JSON.stringify(initialVal);
      }

      return currentVal !== initialVal;
    });
  }

  // Implement canDeactivate for guard
  canDeactivate(): boolean | Observable<boolean> | Promise<boolean> {
    if (!this.hasUnsavedChanges) {
      return true;
    }

    // Return false to trigger confirmation dialog
    return false;
  }

  // Handle browser refresh/close
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: BeforeUnloadEvent): void {
    if (this.hasUnsavedChanges) {
      $event.preventDefault();
      $event.returnValue =
        'Ci sono modifiche non salvate alla fattura. Vuoi davvero uscire?';
    }
  }

  isLoading: boolean = false; // Initialize as false by default
  errorMessage: string | null = null;

  // True quando questa pagina è stata aperta espandendo un quick-invoice o
  // duplicando una fattura esistente: i valori già scelti/copiati (bollo,
  // cassa, fattura sanitaria) non devono essere sovrascritti dai default
  // dell'organization caricati da loadSettings().
  private externalDraftApplied = false;

  myControl = new FormControl('');
  productControl = new FormControl('');
  companySource = new MatTableDataSource<CompanyInterface>([]); // now usng MatTableDataSource

  ngOnInit() {
    this.dateAdapter.setLocale('it-IT');

    // company pre-selection from company table
    this.route.queryParams.subscribe((params) => {
      if (params['companyId']) {
        // If company data is passed via route
        this.newInvoice.company_id = +params['companyId'];
        this.newInvoice.company = {
          id: +params['companyId'],
          company_name: params['companyName'],
        } as CompanyInterface;

        this.showSuccessMessage(
          `Cliente ${params['companyName']} preselezionato`,
        );
      }

      // document type pre-selection
      if (params['documentType']) {
        const documentTypeCode = params['documentType'];
        const foundDocumentType = this.documentTypeOptions.find(
          (option) => option.code === documentTypeCode,
        );

        if (foundDocumentType) {
          this.newInvoice.document_type = foundDocumentType.code;
          // this.showSuccessMessage(
          //   `Tipo documento ${foundDocumentType.name} preselezionato`
          // );
        }
      }
    });

    // Draft in arrivo dal quick-invoice bottom sheet ("Espandi in fattura
    // completa") o da invoice-detail ("Duplica"): i metodi consume*() li
    // svuotano subito, così non si ri-applicano a un refresh o a un ritorno
    // successivo su questa pagina.
    const draft = this.quickInvoiceTransferService.consumeDraft();
    const duplicateDraft =
      this.quickInvoiceTransferService.consumeInvoiceDuplicateDraft();
    if (draft) {
      this.externalDraftApplied = true;
      this.applyQuickInvoiceDraft(draft);
    } else if (duplicateDraft) {
      this.externalDraftApplied = true;
      this.applyInvoiceDuplicateDraft(duplicateDraft);
    }

    this.scrollToTop();
    this.loadAtecoCodes();
    // Se arriviamo dal quick-invoice, numero progressivo e numerazione sono
    // già stati impostati da applyQuickInvoiceDraft con i valori scelti
    // dall'utente nel bottom sheet: non vanno sovrascritti dal calcolo
    // automatico (altrimenti si perderebbe il valore inserito e si rischia
    // un mismatch con quanto già mostrato nel bottom sheet). Duplicando una
    // fattura, invece, vogliamo sempre un numero nuovo: setNextProgressiveNumber()
    // deve girare anche in quel caso.
    if (!draft) {
      this.setNextProgressiveNumber();
    }
    this.loadSettings();

    this.getOrganization();

    this.cdr.detectChanges();
  }

  // Riusa la logica esistente di new-invoice (calcolo importi, withholding,
  // marca da bollo) per applicare un draft arrivato dal quick-invoice
  // bottom sheet, in modo che il risultato sia identico a quello che si
  // otterrebbe inserendo i dati manualmente in questa pagina.
  private applyQuickInvoiceDraft(draft: QuickInvoiceDraft): void {
    // 1. Marca da bollo, prima di tutto: incide sulla base di calcolo della RIVALSA
    this.onRevenueStampOptionChange(draft.revenueStampOption);

    // 2. Cliente
    if (draft.company) {
      this.onCompanySelected(draft.company);
    }

    // 3. Numero progressivo, numerazione e causale
    this.newInvoice.progressive_number = draft.progressiveNumber;
    this.newInvoice.enumeration = draft.enumeration;
    this.newInvoice.description = draft.description;

    // 3bis. Fattura cartacea / prestazione sanitaria
    this.newInvoice.paper_invoice = draft.isPaperInvoice;
    this.newInvoice.healthcare_invoice = draft.isHealthcareInvoice;

    // 3ter. Codice ATECO: se non scelto nel quick-invoice (nessun codice
    // disponibile), si lascia che loadAtecoCodes() applichi il default
    // (primo codice) appena i codici sono caricati.
    if (draft.atecoCodeId) {
      this.newInvoice.ateco_code_id = draft.atecoCodeId;
    }

    // 3quater. Metodo di pagamento, data di emissione, termini di pagamento
    // e codice destinatario: il codice destinatario va impostato dopo
    // onCompanySelected() (step 2), che lo sovrascriverebbe altrimenti con
    // quello di default dell'anagrafica.
    this.newInvoice.payment_method = draft.paymentMethod;
    this.newInvoice.emission_date = draft.emissionDate;
    this.newInvoice.payment_days = draft.paymentDays;
    this.newInvoice.payment_date = this.calculatePaymentDate(
      draft.emissionDate,
      draft.paymentDays,
    );
    this.newInvoice.addressee_code = draft.addresseeCode;
    this.newInvoice.iban = draft.iban;
    this.validateIban();

    // 4. Cassa previdenziale: va impostata prima di aggiungere la withholding
    // CASSA, perché lo slide-panel "Cassa previdenziale" nel template legge da lì.
    if (draft.withholdings.some((w) => w.kind === 'CASSA')) {
      this.newInvoice.pension_fund_type = draft.cassaPensionFundType;
    }

    // 5. Righe prodotto
    for (const line of draft.productLines) {
      this.newProductService = {
        invoice_id: 1,
        name: line.name,
        quantity: line.quantity,
        units: line.units,
        gross_amount: line.gross_amount,
        discount: line.discount,
        discount_amount: 0,
        amount: 0,
        description: line.description,
        iva_percentage: 0,
        iva_amount: 0,
        final_amount: 0,
      };
      this.calculateFinalAmount();
      this.addNewProductService();
    }

    // 6. Contributi
    for (const withholding of draft.withholdings) {
      this.newTaxWithholding = {
        kind: withholding.kind,
        rate_percentage: withholding.rate_percentage,
        total_percentage: 100,
        details: '',
        rate_amount: 0,
        total_amount: 0,
      };
      this.calculateTaxWithholdingTotal();
      this.addNewTaxWithholding();
    }

    this.calculateAllTaxWithholdings();
    this.markAsChanged();
    this.cdr.detectChanges();
  }

  // Applica un draft arrivato da invoice-detail ("Duplica"): a differenza del
  // quick-invoice, qui la fonte è già un InvoiceInterface completo, quindi la
  // mappatura sui campi di newInvoice è diretta invece che tramite un modello
  // semplificato. Numero progressivo ed enumeration NON vengono copiati
  // dall'originale: restano quelli calcolati da setNextProgressiveNumber()
  // (chiamato comunque in ngOnInit per questo tipo di draft), altrimenti si
  // rischierebbe di riusare un numero già trasmesso.
  private applyInvoiceDuplicateDraft(draft: InvoiceDuplicateDraft): void {
    const { invoice } = draft;

    // 1. Marca da bollo, prima di tutto: incide sulla base di calcolo della RIVALSA
    this.onRevenueStampOptionChange(draft.revenueStampOption);

    // 2. Cliente
    this.newInvoice.company_id = invoice.company_id;
    this.newInvoice.company = invoice.company;
    this.newInvoice.addressee_code = invoice.addressee_code;
    this.newInvoice.addressee_name = invoice.addressee_name;

    // 3. Dati generali del documento
    this.newInvoice.document_type = invoice.document_type;
    this.newInvoice.description = invoice.description;
    this.newInvoice.description_internal = invoice.description_internal;
    this.newInvoice.notes = invoice.notes;
    this.newInvoice.language = invoice.language;
    this.newInvoice.currency = invoice.currency;
    this.newInvoice.payment_method = invoice.payment_method;
    this.newInvoice.iban = invoice.iban;
    this.newInvoice.iva_collectability = invoice.iva_collectability;
    this.newInvoice.p_a = invoice.p_a;
    this.newInvoice.paper_invoice = invoice.paper_invoice;
    this.newInvoice.healthcare_invoice = invoice.healthcare_invoice;
    this.newInvoice.document_id = invoice.document_id;
    this.newInvoice.cig = invoice.cig;
    this.newInvoice.cup = invoice.cup;
    this.newInvoice.cod_comm_conv = invoice.cod_comm_conv;
    this.newInvoice.id_document_date = invoice.id_document_date;
    this.newInvoice.id_document_voice = invoice.id_document_voice;
    this.newInvoice.rif_righe_fatt = invoice.rif_righe_fatt;

    if (invoice.ateco_code_id) {
      this.newInvoice.ateco_code_id = invoice.ateco_code_id;
    }

    // 4. Date e termini di pagamento: nuova data di emissione (oggi).
    // payment_days è un campo solo-client (non restituito dal backend), quindi
    // lo ricavo dalla differenza reale fra emission_date e payment_date
    // dell'originale, invece di azzerarlo (altrimenti "termini di pagamento"
    // risulterebbe sempre 0 su una fattura duplicata).
    const today = format(new Date(), 'yyyy-MM-dd');
    let paymentDays = 0;
    if (invoice.emission_date && invoice.payment_date) {
      const originalDiff = differenceInCalendarDays(
        parseISO(String(invoice.payment_date)),
        parseISO(String(invoice.emission_date)),
      );
      if (!isNaN(originalDiff) && originalDiff > 0) {
        paymentDays = originalDiff;
      }
    }
    this.newInvoice.emission_date = today;
    this.newInvoice.payment_days = paymentDays;
    this.newInvoice.payment_date = this.calculatePaymentDate(
      today,
      paymentDays,
    );

    // 5. Cassa previdenziale: va impostata prima di aggiungere la withholding
    // CASSA, perché lo slide-panel "Cassa previdenziale" nel template legge da lì.
    if (invoice.pension_fund_rate > 0) {
      this.newInvoice.pension_fund_type = invoice.pension_fund_type;
    }

    // 6. Righe prodotto
    for (const line of draft.productServices) {
      this.newProductService = {
        invoice_id: 1,
        name: line.name,
        quantity: line.quantity,
        units: line.units,
        gross_amount: line.gross_amount,
        discount: line.discount,
        discount_amount: 0,
        amount: 0,
        description: line.description,
        iva_percentage: line.iva_percentage,
        iva_amount: 0,
        final_amount: 0,
      };
      this.calculateFinalAmount();
      this.addNewProductService();
    }

    // 7. Contributi: una voce per ciascun tipo con aliquota > 0 sull'originale.
    // Le aliquote arrivano dal backend come DecimalField, serializzati da DRF
    // come stringhe (es. "4.00"): Number(...) le normalizza prima di usarle,
    // altrimenti roundToTwo() più avanti le trasforma in NaN (concatenazione
    // invece di somma con Number.EPSILON).
    const revengeRate = Number(invoice.revenge_rate) || 0;
    const pensionFundRate = Number(invoice.pension_fund_rate) || 0;
    const withholdingAdvanceTaxRate =
      Number(invoice.withholding_advance_tax_rate) || 0;
    const withholdingTaxRate = Number(invoice.withholding_tax_rate) || 0;

    const withholdings: { kind: KindCode; rate_percentage: number }[] = [];
    if (revengeRate > 0) {
      withholdings.push({ kind: 'RIVALSA', rate_percentage: revengeRate });
    }
    if (pensionFundRate > 0) {
      withholdings.push({ kind: 'CASSA', rate_percentage: pensionFundRate });
    }
    if (withholdingAdvanceTaxRate > 0) {
      withholdings.push({
        kind: 'RITENUTA_ACCONTO',
        rate_percentage: withholdingAdvanceTaxRate,
      });
    }
    if (withholdingTaxRate > 0) {
      withholdings.push({
        kind: 'RITENUTA',
        rate_percentage: withholdingTaxRate,
      });
    }

    for (const withholding of withholdings) {
      this.newTaxWithholding = {
        kind: withholding.kind,
        rate_percentage: withholding.rate_percentage,
        total_percentage: 100,
        details: '',
        rate_amount: 0,
        total_amount: 0,
      };
      this.calculateTaxWithholdingTotal();
      this.addNewTaxWithholding();
    }

    this.calculateAllTaxWithholdings();
    this.markAsChanged();
    this.cdr.detectChanges();
  }

  private getOrganization() {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    if (organization_id && !isNaN(organization_id)) {
      const filterParams = {
        organization_id: organization_id,
      };

      console.log(this.organization_data?.source);

      this.organizationService
        .getOrganization<Organizations>(organization_id, filterParams)
        .subscribe({
          next: (organization_data: Organizations) => {
            console.log('Organization:', organization_data);
            this.organization_data = organization_data;
            this.cdr.detectChanges();
          },
          error: (err: any) => {
            console.error('Error loading organization:', err);
            this.cdr.detectChanges();
          },
        });
    } else {
      console.error(
        'Could not extract valid organization ID from URL or route parameters',
      );
    }
  }

  private loadSettings(): void {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    if (!organization_id) {
      console.warn('No organization ID found in route');
      return;
    }

    this.isLoading = true;

    this.organizationService.getOrganization(organization_id, {}).subscribe({
      next: (organization: any) => {
        // Se la pagina è stata aperta espandendo un quick-invoice o
        // duplicando una fattura, questi valori sono già stati impostati:
        // non vanno sovrascritti con i default dell'organization.
        if (!this.externalDraftApplied) {
          // Automatically set healthcare_invoice based on organization's is_healthcare
          if (organization.is_healthcare) {
            this.newInvoice.healthcare_invoice = true;
          } else {
            this.newInvoice.healthcare_invoice = false;
          }
          // revenue stamp
          if (organization.has_revenue_stamp_for_company) {
            this.newInvoice.revenue_stamp = 2;
            this.invoice_revenue_stamp = 2;
            this.newInvoice.revenue_stamp_for_company = true;
            this.revenueStampOption = 'customer';
          } else {
            this.newInvoice.revenue_stamp = 0;
            this.invoice_revenue_stamp = 0;
            this.newInvoice.revenue_stamp_for_company = false;
            this.revenueStampOption = 'none';
          }
          if (organization.favorite_pension_fund) {
            this.newInvoice.pension_fund_type =
              organization.favorite_pension_fund;
          } else {
            this.newInvoice.pension_fund_type = 'TC22';
          }
        }

        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: (err: any) => {
        console.error('Error loading organization settings:', err);
        this.isLoading = false;
        // Don't show error message to user for this, just use default values
        // (a meno che non arrivi già da un quick-invoice o da un duplicato già compilato)
        if (!this.externalDraftApplied) {
          this.newInvoice.healthcare_invoice = false; // Default to false if error
        }
        this.cdr.detectChanges();
      },
    });
  }

  private scrollToTop() {
    // window.scrollTo(0, 0);
    // Alternatively, for smoother scrolling:
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  getDocumentTypeName(code: string): string {
    const found = this.documentTypeOptions.find(
      (option) => option.code === code,
    );

    // also change the enumeration
    if (found && found.code === 'TD04') {
      this.newInvoice.enumeration = 'NC';
    } else {
      this.newInvoice.enumeration = format(new Date(), 'yyyy');
    }

    return found ? found.name : 'Documento';
  }

  private setNextProgressiveNumber(): void {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    if (organization_id) {
      this.invoiceService.getMaxProgressiveNumber(organization_id).subscribe({
        next: (maxProgressive: number) => {
          // Set progressive_number to max + 1, or 1 if no invoices exist
          this.newInvoice.progressive_number = (maxProgressive || 0) + 1;
          console.log(
            `Auto-set progressive number to: ${this.newInvoice.progressive_number}`,
          );
        },
        error: (err: any) => {
          console.error('Error fetching max progressive number:', err);
          // Fallback to 1 if there's an error
          this.newInvoice.progressive_number = 1;
          this.showErrorMessage(
            'Errore nel caricamento del numero progressivo. Usando valore predefinito.',
          );
        },
      });
      this.cdr.detectChanges();
    } else {
      // Fallback if no organization ID
      this.newInvoice.progressive_number = 1;
      this.cdr.detectChanges();
    }
  }

  private loadAtecoCodes() {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.isLoading = true;
    this.errorMessage = null;

    this.AtecoCodesApi.getAllAtecoCodes<AtecoCodeInterface>(
      organization_id,
      {},
    ).subscribe({
      next: (response: RecursiveInterface<AtecoCodeInterface>) => {
        if (response.completed) {
          // Store all ATECO codes in the component property
          this.atecoCodes = response.results;

          // Auto-select first item in the newInvoice object
          if (
            this.atecoCodes.length > 0 &&
            (this.newInvoice.ateco_code_id === undefined ||
              this.newInvoice.ateco_code_id === null ||
              this.newInvoice.ateco_code_id === 0)
          ) {
            this.newInvoice.ateco_code_id = this.atecoCodes[0].id;
          }

          console.log('All ateco codes loaded', this.atecoCodes.length);
          console.log('Selected ATECO code ID:', this.newInvoice.ateco_code_id);
        } else {
          // Optional: Show loading progress
          console.log(
            `Loaded ${response.results.length} saved ateco codes so far...`,
          );
          this.atecoCodes = response.results;
        }
        this.isLoading = false;
      },
      error: (err: any) => {
        this.isLoading = false;
        console.error('Error loading ateco codes:', err);
        this.showErrorMessage('Errore nel caricamento dei codici ATECO.');
      },
    });
  }

  onAtecoCodeChange(event: any): void {
    // The value is now automatically bound to newInvoice.ateco_code_id
    // You can still perform additional logic here if needed
    const selectedAteco = this.atecoCodes.find(
      (code) => code.id === event.value,
    );
    console.log('Selected ATECO code ID:', this.newInvoice.ateco_code_id);
    console.log('Selected ATECO object:', selectedAteco);

    // You can also update other properties if needed
    // For example, if you want to store the full ATECO object:
    // this.newInvoice.ateco_code = selectedAteco;
  }

  onRevenueStampChange(value: any) {
    this.newInvoice.revenue_stamp = value;
    this.invoice_revenue_stamp = value;

    // Trigger full recalculation
    this.calculateAllTaxWithholdings();
    this.cdr.detectChanges();
  }

  detectChanges() {
    this.cdr.detectChanges();
  }

  onRevenueStampOptionChange(option: 'none' | 'customer' | 'me') {
    this.revenueStampOption = option;

    // Update the actual revenue stamp values based on selection
    if (option === 'customer') {
      this.newInvoice.revenue_stamp = 2;
      this.invoice_revenue_stamp = 2;
      this.newInvoice.revenue_stamp_for_company = true;
    } else if (option === 'me') {
      this.newInvoice.revenue_stamp = 0;
      this.invoice_revenue_stamp = 0;
      this.newInvoice.revenue_stamp_for_company = false;
      this.invoice_revenue_stamp_on_user = true;
      // When it's on you, the stamp exists but doesn't get added to customer total
    } else {
      this.newInvoice.revenue_stamp = 0;
      this.invoice_revenue_stamp = 0;
      this.newInvoice.revenue_stamp_for_company = false;
      this.invoice_revenue_stamp_on_user = false;
    }

    // Trigger full recalculation
    // this.cdr.detectChanges();
    this.calculateAllTaxWithholdings();
    // setTimeout(() => {
    //   this.calculateAllTaxWithholdings();
    //   this.cdr.detectChanges();
    // }, 0);
    this.cdr.detectChanges();
  }

  onRevenueStampCustomerChange(event: MatSlideToggleChange) {
    if (event.checked) {
      this.revenueStampOption = 'customer';
      this.onRevenueStampOptionChange('customer');
    } else if (this.revenueStampOption === 'customer') {
      this.revenueStampOption = 'none';
      this.onRevenueStampOptionChange('none');
    }

    // this.newInvoice.revenue_stamp = this.invoice_revenue_stamp;

    this.cdr.detectChanges();
  }

  onRevenueStampMeChange(event: MatSlideToggleChange) {
    if (event.checked) {
      this.revenueStampOption = 'me';
      this.onRevenueStampOptionChange('me');
    } else if (this.revenueStampOption === 'me') {
      this.revenueStampOption = 'none';
      this.onRevenueStampOptionChange('none');
    }

    this.cdr.detectChanges();
  }

  // methods for tax withholdings
  calculateTaxWithholdingTotal(): void {
    // You can add calculation logic here based on your business rules
    const rate_percentage = this.newTaxWithholding.rate_percentage || 0;
    const total_percentage = this.newTaxWithholding.total_percentage || 0;

    this.newTaxWithholding.rate_percentage = this.roundToTwo(rate_percentage);

    // compute total amount
    this.newTaxWithholding.rate_amount =
      (rate_percentage / 100) *
      (this.invoice_total_amount * (total_percentage / 100));
  }

  getKindDisplayName(kind: string | undefined): string {
    if (!kind) return 'voce';

    const kindMap: { [key: string]: string } = {
      CASSA: 'cassa',
      RIVALSA: 'rivalsa',
      RITENUTA: 'ritenuta',
      RITENUTA_ACCONTO: "ritenuta d'acconto",
    };
    return kindMap[kind] || 'voce';
  }

  isKindAlreadyUsed(kind: string | undefined): boolean {
    if (!kind) return false;
    return this.taxWithholdings.some(
      (withholding) => withholding.kind === kind,
    );
  }

  getAvailableKinds(): KindOptions[] {
    return this.kindOptions.filter(
      (kind) => !this.isKindAlreadyUsed(kind.code),
    );
  }

  // this method to set the first available kind
  setFirstAvailableKind(): void {
    const availableKinds = this.getAvailableKinds();
    if (availableKinds.length > 0) {
      this.newTaxWithholding.kind = availableKinds[0].code;
    }
  }

  setDefaultRate(kindCode: string) {
    this.newTaxWithholding.kind = kindCode as KindCode;

    switch (kindCode) {
      case 'CASSA':
        this.newTaxWithholding.rate_percentage = 4;
        break;
      case 'RIVALSA':
        this.newTaxWithholding.rate_percentage = 4;
        break;
      case 'RITENUTA':
        this.newTaxWithholding.rate_percentage = 20; // Different percentage for ritenuta
        break;
      case 'RITENUTA_ACCONTO':
        this.newTaxWithholding.rate_percentage = 20; // Different percentage for ritenuta acconto
        break;
      default:
        // Keep existing rate or set to 0
        this.newTaxWithholding.rate_percentage = 0;
    }

    this.calculateTaxWithholdingTotal();
  }

  addNewTaxWithholding(): void {
    this.calculateTaxWithholdingTotal();

    if (this.newTaxWithholding.total_percentage !== undefined) {
      // Check if a withholding of this kind already exists
      const existingKind = this.taxWithholdings.find(
        (withholding) => withholding.kind === this.newTaxWithholding.kind,
      );

      if (existingKind) {
        this.showErrorMessage(
          `È già presente una ${this.getKindDisplayName(
            this.newTaxWithholding.kind,
          )}. Puoi averne solo una per tipo.`,
        );
        return;
      }

      // Add the current tax withholding to the array
      this.taxWithholdings.push({ ...this.newTaxWithholding });

      this.numero_contributi += 1;

      // Recalculate all withholdings in the correct order INCLUDING revenue stamp
      this.calculateAllTaxWithholdings();

      this.showSuccessMessage(
        `${this.getKindDisplayName(this.newTaxWithholding.kind)} aggiunta`,
      );

      // Reset the form for new entry
      this.newTaxWithholding = {
        kind: 'CASSA',
        rate_percentage: 0,
        total_percentage: 100,
        details: '',
        rate_amount: 0,
        total_amount: 0,
      };
    } else {
      this.showErrorMessage('Inserisci i dati');
    }
  }

  removeTaxWithholding(index: number): void {
    const removedKind = this.taxWithholdings[index].kind;

    // Remove from array
    this.taxWithholdings.splice(index, 1);

    this.numero_contributi -= 1;

    // Recalculate everything INCLUDING revenue stamp
    this.calculateAllTaxWithholdings();

    this.showSuccessMessage(`${this.getKindDisplayName(removedKind)} rimossa.`);

    // If the removed kind was selected in the form, reset the form
    if (this.newTaxWithholding.kind === removedKind) {
      this.newTaxWithholding = {
        kind: 'CASSA',
        rate_percentage: 0,
        total_percentage: 100,
        details: '',
        rate_amount: 0,
        total_amount: 0,
      };
    }

    this.cdr.detectChanges();
  }

  calculatePaymentDate(
    emissionDate: string | undefined | null,
    days: number,
  ): string {
    if (!emissionDate) {
      emissionDate = format(new Date(), 'yyyy-MM-dd');
    }
    const date = parseISO(emissionDate);
    const paymentDate = addDays(date, days);
    return format(paymentDate, 'yyyy-MM-dd');
  }

  async addNewElement(form?: NgForm, onlyForPreview: boolean = false) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    let savedDialogResult: boolean = true;

    // asks the user for confirmation
    // not in only preview mode
    if (onlyForPreview === false) {
      const dialogRef = this.dialog.open(ConfirmInvoiceDialogComponent, {
        width: '90vw',
        maxWidth: '400px',
        height: '400px',
        data: {
          organization_source: this.organization_data?.source,
        },
      });
      const result = await dialogRef.afterClosed().toPromise();

      if (!result) {
        // User cancelled the dialog
        return;
      }
    } else {
      const savedDialogResult = true;
    }

    // only preview mode
    if (onlyForPreview === true) {
      this.newInvoice.is_saved_for_preview = true;
      this.newInvoice.invoice_name = '(Anteprima)';
    } else {
      this.newInvoice.is_saved_for_preview = false;
      this.newInvoice.invoice_name = '';
    }

    // Check if emission date is more than 12 days ago
    if (this.newInvoice.emission_date) {
      const emissionDate = new Date(this.newInvoice.emission_date);
      const twelveDaysAgo = new Date();
      twelveDaysAgo.setDate(twelveDaysAgo.getDate() - 12);

      // Reset times to compare only dates
      emissionDate.setHours(0, 0, 0, 0);
      twelveDaysAgo.setHours(0, 0, 0, 0);

      if (emissionDate < twelveDaysAgo) {
        // Date is more than 12 days ago - show confirmation dialog
        const dateDialogRef = this.dialog.open(ConfirmDateDialogComponent, {
          width: '90vw',
          maxWidth: '450px',
          height: '400px',
          data: {
            emissionDate: this.newInvoice.emission_date,
            formattedDate: format(emissionDate, 'dd/MM/yyyy'),
            daysAgo: Math.floor(
              (new Date().getTime() - emissionDate.getTime()) /
                (1000 * 60 * 60 * 24),
            ),
          },
        });

        const dateResult = await dateDialogRef.afterClosed().toPromise();

        if (!dateResult) {
          // User cancelled or said the date is incorrect
          this.showErrorMessage(
            'Operazione annullata. Correggi la data di emissione.',
          );
          return;
        } else {
          // force invoice to be non-electronic if this happens
          this.newInvoice.paper_invoice = true;
        }
      }
    }

    if (
      this.newInvoice.company?.iva_number === '' &&
      // || this.newInvoice.company?.c_f === '') &&
      onlyForPreview === false
    ) {
      const checkCompanyDialogRef = this.dialog.open(
        ConfirmInvoiceCompanyDataDialogComponent,
        {
          width: '90vw',
          maxWidth: '400px',
          height: '400px',
          data: {
            c_f: this.newInvoice.company?.c_f,
            iva_number: this.newInvoice.company?.iva_number,
          },
        },
      );
      const checkCompanyResult = await checkCompanyDialogRef
        .afterClosed()
        .toPromise();

      if (!checkCompanyResult) {
        // User cancelled the dialog
        return;
      }
    }

    // only preview invoices are also drafts
    if (onlyForPreview === false) {
      this.newInvoice.is_draft = false;
    } else {
      this.newInvoice.is_draft = true;
    }

    this.newInvoice.addressee_name = this.newInvoice.company?.company_name;

    // Set the invoice amount to the accumulated total
    if (this.newInvoice.revenue_stamp_for_company === true) {
      this.newInvoice.gross_amount =
        this.invoice_gross_amount + this.invoice_revenue_stamp;
    } else {
      this.newInvoice.gross_amount = this.invoice_gross_amount;
    }

    this.onRevenueStampChange(this.invoice_revenue_stamp);
    this.newInvoice.revenue_stamp = this.newInvoice.revenue_stamp;
    if (this.revenueStampOption === 'me') {
      this.newInvoice.revenue_stamp = 2;
    }

    this.newInvoice.amount = Number(this.invoice_total_paid_amount); // invoice_total_amount
    this.newInvoice.iva_amount = this.invoice_iva_amount;
    this.newInvoice.discount_amount = this.invoice_discount_amount;

    // compute the tax withholdings
    this.newInvoice.revenge = Number(this.rivalsa_total);
    this.newInvoice.revenge_rate = Number(this.rivalsa_rate);
    this.newInvoice.pension_fund = Number(this.cassa_total);
    this.newInvoice.pension_fund_rate = Number(this.cassa_rate);
    this.newInvoice.taxable_amount = Number(this.total_taxable);
    this.newInvoice.withholding_advance_tax = Number(
      this.ritenuta_acconto_total,
    );
    this.newInvoice.withholding_advance_tax_rate = Number(
      this.ritenuta_acconto_rate,
    );
    this.newInvoice.withholding_tax = Number(this.ritenuta_total);
    this.newInvoice.withholding_tax_rate = Number(this.ritenuta_rate);

    const formattedEmissionDate = format(
      new Date(this.newInvoice.emission_date!),
      'yyyy-MM-dd',
    );
    const formattedPaymentDate = format(
      new Date(this.newInvoice.payment_date!),
      'yyyy-MM-dd',
    );

    this.newInvoice.emission_date = formattedEmissionDate;
    this.newInvoice.payment_date = formattedPaymentDate;

    // validate required fields
    // console.log(
    //   !this.newInvoice.organization_id || !this.newInvoice.company?.id,
    // );
    // console.log(this.newInvoice);

    // this.onRevenueStampChange(this.invoice_revenue_stamp);
    // this.newInvoice.revenue_stamp = this.newInvoice.revenue_stamp;
    // if (this.revenueStampOption === 'me') {
    //   this.newInvoice.revenue_stamp = 2;
    // }

    // compute payment date
    this.newInvoice.payment_date = this.calculatePaymentDate(
      this.newInvoice.emission_date || format(new Date(), 'yyyy-MM-dd'),
      this.newInvoice.payment_days || 0,
    );

    // console.log('Final:', this.newInvoice); // debugging

    // show a loading
    if (savedDialogResult) {
      // User confirmed - show loading dialog
      const loadingDialogRef = this.dialog.open(LoadingDialogComponent, {
        width: '90vw',
        maxWidth: '400px',
        height: '300px',
        disableClose: true, // Prevent closing during loading
      });

      // Combine fake delay with actual API call
      await Promise.all([
        new Promise((resolve) => setTimeout(resolve, 700)), // less than 1-second delay
      ]);

      this.invoiceService
        .createInvoice(organization_id, this.newInvoice)
        .subscribe({
          next: (createdInvoice: InvoiceInterface) => {
            // Now save all product services for this invoice
            const productServices$ =
              this.productServices.length > 0
                ? this.saveProductServicesForInvoice(
                    createdInvoice.id!,
                    organization_id,
                  )
                : new Observable<ProductServiceInterface[]>((observer) => {
                    observer.next([]);
                    observer.complete();
                  });

            // Now save all tax withholdings for this invoice
            const taxWithholdings$ =
              this.taxWithholdings.length > 0
                ? this.saveTaxWithholdingsForInvoice(
                    createdInvoice.id!,
                    organization_id,
                  )
                : new Observable<TaxWithholdingInterface[]>((observer) => {
                    observer.next([]);
                    observer.complete();
                  });

            // Wait for both product services and tax withholdings to complete
            forkJoin([productServices$, taxWithholdings$]).subscribe({
              next: ([savedServices, savedWithholdings]) => {
                console.log(
                  'All product services saved successfully:',
                  savedServices,
                );
                console.log(
                  'All tax withholdings saved successfully:',
                  savedWithholdings,
                );

                // Update local arrays with saved data (with real IDs)
                this.productServices = savedServices.map((service, index) => ({
                  ...this.productServices[index],
                  id: service.id,
                }));

                this.taxWithholdings = savedWithholdings.map(
                  (withholding, index) => ({
                    ...this.taxWithholdings[index],
                    id: withholding.id,
                  }),
                );

                // only preview mode
                if (onlyForPreview === false) {
                  const successMessage = `${createdInvoice.invoice_name} (totale: ${createdInvoice.amount} ${createdInvoice.currency}) creata!`;
                  // this.showSuccessMessage(successMessage);
                  this.resetForm(form);

                  // Show download confirmation dialog
                  this.openDownloadConfirmationDialog(createdInvoice);
                } else {
                  this.onViewPdfClick(createdInvoice.id);
                }

                loadingDialogRef.close();

                // only preview mode
                if (onlyForPreview === false) {
                  this.backToTable();
                }
              },
              error: (error) => {
                console.error(
                  'Error saving product services or tax withholdings:',
                  error,
                );
                this.showSuccessMessage(
                  `${createdInvoice.invoice_name} creata, ma errore nel salvataggio delle voci o contributi.`,
                );
                this.resetForm(form);
                loadingDialogRef.close();
              },
            });

            this.hasUnsavedChanges = false;
            // Update initial states to current values
            this.initialInvoiceState = { ...this.newInvoice };
            this.initialProductState = { ...this.newProductService };
            this.initialTaxState = { ...this.newTaxWithholding };

            // only preview mode
            if (onlyForPreview === false) {
              this.backToTable();
            }
          },
          error: (err: any) => {
            console.error('Error creating invoice:', err);
            this.showErrorMessage('Errore durante la creazione. Riprovare.');
          },
        });

      // Close loading dialog
      loadingDialogRef.close();
    }
  }

  openDownloadConfirmationDialog(invoice: InvoiceInterface): void {
    const downloadDialogRef = this.dialog.open(
      DownloadConfirmationDialogComponent,
      {
        width: '90vw',
        maxWidth: '500px',
        data: {
          title: `${this.getDocumentTypeName(
            invoice.document_type!,
          )} creata con successo!`,
          documentType: 'Il documento',
          invoiceId: invoice.id!,
          invoiceName: invoice.invoice_name,
          companyName: invoice.company.company_name,
          text: 'è stato creato correttamente.',
        },
      },
    );

    downloadDialogRef.afterClosed().subscribe(async (result) => {
      if (result && result.download) {
        this.downloadPdf(invoice.id!);
      } else if (result && result.sendEmail) {
        await this.sendInvoiceEmail(invoice.id!, invoice);
      }
    });
  }

  async sendInvoiceEmail(
    invoiceId: number,
    invoice: InvoiceInterface,
  ): Promise<void> {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    const dialogRef = this.dialog.open(ConfirmEmailSendDialogComponent, {
      width: '90vw',
      maxWidth: '400px',
      height: '400px',
      data: {
        email_address: invoice.company.email_address,
        company_id: invoice.company.id,
        organization_id: organization_id,
      },
    });
    const confirmed = await dialogRef.afterClosed().toPromise();

    if (!confirmed) {
      return;
    }

    const loadingDialogRef = this.dialog.open(LoadingDialogComponent, {
      width: '90vw',
      maxWidth: '400px',
      height: '220px',
      disableClose: true,
    });

    try {
      await this.invoiceService.sendEmailWithPDF(
        organization_id,
        invoiceId,
        invoice,
      );
      loadingDialogRef.close();
      this.showSuccessMessage(
        `La fattura è stata inviata al cliente con successo!`,
      );
    } catch (error) {
      loadingDialogRef.close();
      this.showErrorMessage('Errore invio email con PDF.');
    }
  }

  saveTaxWithholdingsForInvoice(
    invoiceId: number,
    organizationId: number,
  ): Observable<TaxWithholdingInterface[]> {
    if (this.taxWithholdings.length === 0) {
      return new Observable<TaxWithholdingInterface[]>((observer) => {
        observer.next([]);
        observer.complete();
      });
    }

    const saveObservables: Observable<TaxWithholdingInterface>[] =
      this.taxWithholdings.map((withholding) => {
        const withholdingWithInvoiceId: Partial<TaxWithholdingInterface> = {
          ...withholding,
          invoice_id: invoiceId,
        };

        return this.taxWithholdingApi.createTaxWithholding(
          invoiceId,
          organizationId,
          withholdingWithInvoiceId,
        );
      });

    return forkJoin(saveObservables);
  }

  async saveDraftElement(form?: NgForm) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    const dialogRef = this.dialog.open(ConfirmInvoiceDraftSaveComponent, {
      width: '90vw',
      maxWidth: '400px',
      height: '270px',
    });
    const result = await dialogRef.afterClosed().toPromise();

    if (!result) {
      // User cancelled the dialog
      return;
    }

    if (
      this.newInvoice.company?.iva_number === '' ||
      this.newInvoice.company?.c_f === ''
    ) {
      const checkCompanyDialogRef = this.dialog.open(
        ConfirmInvoiceCompanyDataDialogComponent,
        {
          width: '90vw',
          maxWidth: '400px',
          height: '370px',
          data: {
            c_f: this.newInvoice.company?.c_f,
            iva_number: this.newInvoice.company?.iva_number,
          },
        },
      );
      const checkCompanyResult = await checkCompanyDialogRef
        .afterClosed()
        .toPromise();

      if (!checkCompanyResult) {
        // User cancelled the dialog
        return;
      }
    }

    this.newInvoice.is_draft = true;
    this.newInvoice.is_saved_for_preview = false;
    this.newInvoice.invoice_name = '(Bozza)';

    // skip enumeration
    // this.newInvoice.progressive_number = 0;
    // this.newInvoice.enumeration = 'Bozza';

    this.newInvoice.addressee_name = this.newInvoice.company?.company_name;

    // Set the invoice amount to the accumulated total - use the same calculation as addNewElement
    if (this.newInvoice.revenue_stamp_for_company === true) {
      this.newInvoice.gross_amount =
        this.invoice_gross_amount + this.invoice_revenue_stamp;
    } else {
      this.newInvoice.gross_amount = this.invoice_gross_amount;
    }
    this.newInvoice.revenue_stamp = this.invoice_revenue_stamp;
    this.newInvoice.amount = Number(this.invoice_total_paid_amount); // Use the same final amount calculation
    this.newInvoice.iva_amount = this.invoice_iva_amount;
    this.newInvoice.discount_amount = this.invoice_discount_amount;

    // Include the same tax withholding calculations as addNewElement
    this.newInvoice.revenge = Number(this.rivalsa_total);
    this.newInvoice.revenge_rate = Number(this.rivalsa_rate);
    this.newInvoice.pension_fund = Number(this.cassa_total);
    this.newInvoice.pension_fund_rate = Number(this.cassa_rate);
    this.newInvoice.taxable_amount = Number(this.total_taxable);
    this.newInvoice.withholding_advance_tax = Number(
      this.ritenuta_acconto_total,
    );
    this.newInvoice.withholding_advance_tax_rate = Number(
      this.ritenuta_acconto_rate,
    );
    this.newInvoice.withholding_tax = Number(this.ritenuta_total);
    this.newInvoice.withholding_tax_rate = Number(this.ritenuta_rate);

    const formattedEmissionDate = format(
      new Date(this.newInvoice.emission_date!),
      'yyyy-MM-dd',
    );
    const formattedPaymentDate = format(
      new Date(this.newInvoice.payment_date!),
      'yyyy-MM-dd',
    );

    this.newInvoice.emission_date = formattedEmissionDate;
    this.newInvoice.payment_date = formattedPaymentDate;

    // validate required fields
    // console.log(
    //   !this.newInvoice.organization_id || !this.newInvoice.company?.id,
    // );
    // console.log(this.newInvoice);

    this.onRevenueStampChange(this.invoice_revenue_stamp);

    // compute payment date
    this.newInvoice.payment_date = this.calculatePaymentDate(
      this.newInvoice.emission_date || format(new Date(), 'yyyy-MM-dd'),
      this.newInvoice.payment_days || 0,
    );

    // console.log('Final Draft:', this.newInvoice);

    // Show loading dialog for draft as well
    const loadingDialogRef = this.dialog.open(LoadingDialogComponent, {
      width: '90vw',
      maxWidth: '400px',
      height: '300px',
      disableClose: true,
    });

    // Combine fake delay with actual API call
    await Promise.all([new Promise((resolve) => setTimeout(resolve, 700))]);

    this.invoiceService
      .createInvoice(organization_id, this.newInvoice)
      .subscribe({
        next: (createdInvoice: InvoiceInterface) => {
          // Now save all product services for this invoice (same as addNewElement)
          const productServices$ =
            this.productServices.length > 0
              ? this.saveProductServicesForInvoice(
                  createdInvoice.id!,
                  organization_id,
                )
              : new Observable<ProductServiceInterface[]>((observer) => {
                  observer.next([]);
                  observer.complete();
                });

          // Now save all tax withholdings for this invoice (same as addNewElement)
          const taxWithholdings$ =
            this.taxWithholdings.length > 0
              ? this.saveTaxWithholdingsForInvoice(
                  createdInvoice.id!,
                  organization_id,
                )
              : new Observable<TaxWithholdingInterface[]>((observer) => {
                  observer.next([]);
                  observer.complete();
                });

          // Wait for both product services and tax withholdings to complete
          forkJoin([productServices$, taxWithholdings$]).subscribe({
            next: ([savedServices, savedWithholdings]) => {
              console.log(
                'All product services saved successfully for draft:',
                savedServices,
              );
              console.log(
                'All tax withholdings saved successfully for draft:',
                savedWithholdings,
              );

              // Update local arrays with saved data (with real IDs)
              this.productServices = savedServices.map((service, index) => ({
                ...this.productServices[index],
                id: service.id,
              }));

              this.taxWithholdings = savedWithholdings.map(
                (withholding, index) => ({
                  ...this.taxWithholdings[index],
                  id: withholding.id,
                }),
              );

              const successMessage = `Bozza salvata con successo!`;
              this.showSuccessMessage(successMessage);

              this.resetForm(form);
              loadingDialogRef.close();
            },
            error: (error) => {
              console.error(
                'Error saving product services or tax withholdings for draft:',
                error,
              );
              this.showSuccessMessage(
                `${createdInvoice.invoice_name} salvata come bozza, ma errore nel salvataggio delle voci o contributi.`,
              );
              this.resetForm(form);
              loadingDialogRef.close();
            },
          });

          this.hasUnsavedChanges = false;
          // Update initial states to current values
          this.initialInvoiceState = { ...this.newInvoice };
          this.initialProductState = { ...this.newProductService };
          this.initialTaxState = { ...this.newTaxWithholding };

          this.goToDrafts();
        },
        error: (err: any) => {
          console.error('Error creating draft invoice:', err);
          this.showErrorMessage(
            'Errore durante il salvataggio della bozza. Riprovare.',
          );
          loadingDialogRef.close();
        },
      });
  }

  calculateTotalTaxWithholdings(): number {
    return this.taxWithholdings.reduce((total_percentage, withholding) => {
      return total_percentage + (withholding.total_percentage || 0);
    }, 0);
  }

  // Main method to calculate all tax withholdings in the correct order
  calculateAllTaxWithholdings(): void {
    let currentAmount = this.invoice_total_amount; // This is now WITHOUT IVA

    // Step 0: BEFORE add revenue stamp (only if charged to customer)
    if (this.revenueStampOption === 'customer') {
      currentAmount += Number(this.invoice_revenue_stamp);
    }

    // Step 1: Calculate 'rivalsa' withholdings on the original total (without IVA)
    const rivalsaAmount = this.calculateTaxWithholdingsByKind('RIVALSA');
    const invoice_total_amount_with_rivalsa = currentAmount + rivalsaAmount;

    // Step 2: Calculate 'cassa' withholdings on the amount with rivalsa (without IVA)
    const cassaAmount = this.calculateTaxWithholdingsByKind('CASSA');
    const total_taxable = invoice_total_amount_with_rivalsa + cassaAmount;

    // Step 3: NOW calculate IVA on the total_taxable
    const totalIvaAmount = this.calculateTotalIvaAmount(total_taxable);
    const total_with_iva = total_taxable + totalIvaAmount;

    // Step 4: Calculate 'ritenuta' withholdings on the total_with_iva
    const ritenutaAccontoAmount =
      this.calculateTaxWithholdingsByKind('RITENUTA_ACCONTO');
    const invoice_total_paid_amount_with_acconto =
      total_with_iva - ritenutaAccontoAmount;

    // Step 5: Calculate 'ritenuta acconto' withholdings on the total_with_iva
    const ritenutaAmount = this.calculateTaxWithholdingsByKind('RITENUTA');
    let invoice_total_paid_amount =
      invoice_total_paid_amount_with_acconto - ritenutaAmount;

    // Step 6: FINALLY add revenue stamp (only if charged to customer)
    // if (this.revenueStampOption === 'customer') {
    //   invoice_total_paid_amount += Number(this.invoice_revenue_stamp);
    // }

    // Update the final amounts
    this.invoice_total_amount_with_rivalsa = this.roundToTwo(
      invoice_total_amount_with_rivalsa,
    );
    this.total_taxable = this.roundToTwo(total_taxable);
    this.invoice_iva_amount = this.roundToTwo(totalIvaAmount); // Store the total IVA
    this.invoice_total_paid_amount_with_acconto = this.roundToTwo(
      invoice_total_paid_amount_with_acconto,
    );
    this.invoice_total_paid_amount = this.roundToTwo(invoice_total_paid_amount);

    // Store intermediate values for display
    this.rivalsa_total = this.roundToTwo(rivalsaAmount);
    this.cassa_total = this.roundToTwo(cassaAmount);
    this.ritenuta_acconto_total = this.roundToTwo(ritenutaAccontoAmount);
    this.ritenuta_total = this.roundToTwo(ritenutaAmount);
  }

  // Enhanced method to calculate tax withholdings by kind with percentage application
  calculateTaxWithholdingsByKind(kind: KindCode): number {
    return this.taxWithholdings
      .filter((withholding) => withholding.kind === kind)
      .reduce((total, withholding) => {
        let baseAmount = 0;

        // Determine the base amount based on the kind and calculation order
        if (kind === 'RIVALSA') {
          baseAmount = this.invoice_total_amount + this.invoice_revenue_stamp;
          this.newInvoice.pension_fund_type = 'TC22'; // INPS
        } else if (kind === 'CASSA') {
          baseAmount =
            this.invoice_total_amount_with_rivalsa || this.invoice_total_amount;
        } else if (kind === 'RITENUTA_ACCONTO') {
          baseAmount =
            this.invoice_total_amount_with_rivalsa || this.invoice_total_amount;
        } else if (kind === 'RITENUTA') {
          baseAmount = this.invoice_total_amount || this.invoice_total_amount; // FIXME: Sthis.invoice_revenue_stamp ??
        }

        const percentage = withholding.total_percentage || 0;
        const rate = withholding.rate_percentage || 0;

        if (kind === 'RIVALSA') {
          this.rivalsa_rate = rate;
        } else if (kind === 'CASSA') {
          this.cassa_rate = rate;
        } else if (kind === 'RITENUTA_ACCONTO') {
          this.ritenuta_acconto_rate = rate;
        } else if (kind === 'RITENUTA') {
          this.ritenuta_rate = rate;
        }

        // Calculate the amount for this withholding
        const withholdingAmount =
          baseAmount * (percentage / 100) * (rate / 100);

        // Update the withholding object with the calculated amount
        withholding.rate_amount = this.roundToTwo(withholdingAmount);

        return total + withholdingAmount;
      }, 0);
  }

  // Individual methods for each type (optional, for convenience)
  // calculateTotalRivalsa(): number {
  //   return this.calculateTaxWithholdingsByKind('RIVALSA');
  // }

  // calculateTotalCassa(): number {
  //   return this.calculateTaxWithholdingsByKind('CASSA');
  // }

  // calculateTotalRitenute(): number {
  //   return this.calculateTaxWithholdingsByKind('RITENUTA');
  // }

  // Check if any withholdings of a specific kind exist
  hasTaxWithholdingsOfKind(kind: KindCode): boolean {
    return this.taxWithholdings.some(
      (withholding) => withholding.kind === kind,
    );
  }

  // "list"
  productServices: Partial<ProductServiceInterface>[] = [];

  // handy functions
  calculateFinalAmount(): void {
    // Set defaults if undefined
    const gross = this.newProductService.gross_amount || 0;
    const quantity = this.newProductService.quantity || 1;
    const discount = (this.newProductService.discount || 0) / 100;

    // Calculate components WITHOUT IVA for now
    const grossTotal = gross * quantity;
    const discountAmount = grossTotal * discount;
    const taxableAmount = grossTotal - discountAmount;

    // Store the taxable amount (without IVA)
    this.newProductService.amount = this.roundToTwo(taxableAmount);
    this.newProductService.final_amount = this.roundToTwo(taxableAmount); // This will be updated later with IVA

    // Store IVA percentage but don't calculate the amount yet
    // this.newProductService.iva_amount will be calculated later
  }

  // Helper function for proper rounding
  private roundToTwo(num: number): number {
    return Math.round((num + Number.EPSILON) * 100) / 100;
  }

  calculateTotalIvaAmount(taxableBase: number): number {
    // Calculate weighted average IVA percentage from all products
    let totalTaxable = 0;
    let totalIvaWeighted = 0;

    this.productServices.forEach((service) => {
      const serviceTaxable = service.amount || 0;
      const serviceIvaPercentage = service.iva_percentage || 0;

      totalTaxable += serviceTaxable;
      totalIvaWeighted += serviceTaxable * (serviceIvaPercentage / 100);
    });

    if (totalTaxable === 0) return 0;

    // Calculate the effective IVA percentage
    const effectiveIvaPercentage = totalIvaWeighted / totalTaxable;

    // Apply this percentage to the taxable base
    return taxableBase * effectiveIvaPercentage;
  }

  calculateFinalAmountWithTaxWithholding(): void {
    const TaxWithholdingsAmount = this.taxWithholdings.reduce(
      (total, withholding) => total + (withholding.rate_amount || 0),
      0,
    );

    this.invoice_total_amount =
      this.invoice_total_amount + TaxWithholdingsAmount;
  }

  addNewProductService(form?: NgForm) {
    this.calculateFinalAmount();

    this.gross_amount +=
      Number(this.newProductService.gross_amount) *
      Number(this.newProductService.quantity);
    this.newProductService.discount_amount =
      ((this.newProductService.discount_amount || 0) +
        (this.newProductService.gross_amount || 0) *
          (Number(this.newProductService.discount) / 100)) *
      Number(this.newProductService.quantity);

    if (this.newProductService.final_amount) {
      // Add the current product/service to the array
      this.productServices.push({ ...this.newProductService });

      // Update totals WITHOUT IVA
      this.total_amount += Number(this.newProductService.amount); // Use amount (without IVA) instead of final_amount
      this.discount_amount += Number(this.newProductService.discount_amount);
      this.discount += Number(this.newProductService.discount);
      this.numero_articoli += 1;

      // copy them (without IVA for now)
      this.invoice_gross_amount = this.roundToTwo(this.gross_amount);
      this.invoice_total_amount = this.roundToTwo(this.total_amount); // This is now WITHOUT IVA
      this.invoice_discount_amount = this.roundToTwo(this.discount_amount);
      this.invoice_discount = this.roundToTwo(this.discount);

      // Reset IVA amount - it will be calculated later
      this.invoice_iva_amount = 0;

      // Don't add revenue stamp here anymore
      // this.onRevenueStampChange(this.invoice_revenue_stamp);

      // reset the form for new entry
      if (form) {
        form.resetForm();
        this.newProductService = {
          invoice_id: 1,
          name: '',
          quantity: 1,
          units: '',
          gross_amount: 0,
          discount: 0,
          discount_amount: 0,
          amount: 0,
          description: '',
          iva_percentage: 0,
          iva_amount: 0,
          final_amount: 0,
        };
      }

      // Recalculate everything with the new order
      this.calculateAllTaxWithholdings();

      this.showSuccessMessage('Prodotto o servizio aggiunto');
    } else {
      this.showErrorMessage('Inserisci il totale');
    }
  }

  async saveNewProductServiceInSavedList(form?: NgForm) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    const dialogRef = this.dialog.open(ConfirmInvoiceDeleteComponent, {
      width: '90vw',
      maxWidth: '400px',
      height: '270px',
      maxHeight: '90vh',
      data: {
        // invoiceName: invoice.invoice_name,
        title: 'Salva prodotto o servizio',
        message:
          "Questo prodotto o servizio sarà aggiunto all'anagrafica dei Prodotti e Servizi e potrà essere riutilizzato in seguito.", // Custom message
        checkboxLabel: 'Confermo il salvataggio', // Custom checkbox label
      },
    });

    const result = await dialogRef.afterClosed().toPromise();

    if (!result) {
      return;
    }

    const newSavedProduct: Partial<SavedProductInterface> = {
      // id: 1,
      name: '',
      units: '',
      type: 'SERVIZIO',
      unit_price: 0,
      description: '',
      iva_percentage: 0,

      organization_id: 0,
    };

    // set organization_id
    newSavedProduct.organization_id = organization_id;

    if (newSavedProduct.organization_id !== 0) {
      newSavedProduct.name = this.newProductService.name;
      // newSavedProduct.type = this.newProductService.type;
      newSavedProduct.unit_price = this.newProductService.gross_amount;
      newSavedProduct.units = this.newProductService.units;
      newSavedProduct.description = this.newProductService.description;

      this.SavedProductApi.createSavedProduct(
        organization_id,
        newSavedProduct,
      ).subscribe({
        next: (createdSavedProduct: SavedProductInterface) => {
          // this.companySource.data = [...this.companySource.data, createdCompany];

          this.showSuccessMessage(
            `Prestazione ${newSavedProduct.name} aggiunta in anagrafica.`,
          );
        },
        error: (err: any) => {
          console.error('Error creating company:', err);
          this.showErrorMessage(
            'Si è verificato un errore durante il salvataggio.',
          );
        },
      });
    } else {
      return;
    }
  }

  // method for individual creation
  saveProductServicesForInvoice(
    invoiceId: number,
    organizationId: number,
  ): Observable<ProductServiceInterface[]> {
    if (this.productServices.length === 0) {
      return new Observable<ProductServiceInterface[]>((observer) => {
        observer.next([]);
        observer.complete();
      });
    }

    // Create an array of observables for each product service
    const saveObservables: Observable<ProductServiceInterface>[] =
      this.productServices.map((service) => {
        const serviceWithInvoiceId: Partial<ProductServiceInterface> = {
          ...service,
          invoice_id: invoiceId,
        };

        console.log('serviceWithInvoiceId', serviceWithInvoiceId);

        return this.productServiceApi.createProductService(
          invoiceId,
          organizationId,
          serviceWithInvoiceId,
        );
      });

    // Use forkJoin to wait for all requests to complete and return an array
    return forkJoin(saveObservables);
  }

  scrollToProductList(): void {
    if (this.productsListElement) {
      this.productsListElement.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
  }

  clearCompanySelection(): void {
    this.myControl.setValue('');
    this.onCompanySelected(null);
  }

  // validate discount
  // validateDiscount() {
  //   if (this.newProductService.discount > 100) {
  //     this.newProductService.discount = 100;
  //   } else if (this.newProductService.discount < 0) {
  //     this.newProductService.discount = 0;
  //   }
  //   this.calculateFinalAmount();
  // }

  removeProductService(index: number) {
    // Subtract the amount before removing
    this.gross_amount -=
      Number(this.productServices[index].gross_amount) *
      Number(this.productServices[index].quantity);
    this.total_amount -= Number(this.productServices[index].final_amount);
    this.discount_amount -= Number(this.productServices[index].discount_amount);
    this.iva_amount -= Number(this.productServices[index].iva_amount);
    this.numero_articoli -= 1;

    this.invoice_gross_amount = this.gross_amount;
    this.invoice_total_amount = this.total_amount;
    this.invoice_discount_amount = this.discount_amount;
    this.invoice_iva_amount = this.iva_amount;

    this.onRevenueStampChange(this.invoice_revenue_stamp);

    // Remove from array
    this.productServices.splice(index, 1);

    this.calculateAllTaxWithholdings();

    this.showSuccessMessage('Voce rimossa.');
  }

  onCompanySelected(company: CompanyInterface | null): void {
    if (company) {
      this.newInvoice.company_id = company.id;
      this.newInvoice.company = company;
      // invoice addressee code (SDI)
      this.newInvoice.addressee_code = company.addressee_code;

      this.showSuccessMessage(
        `Cliente ${this.newInvoice.company.company_name} selezionato.`,
      );
    } else {
      // Clear the company selection
      this.newInvoice.company_id = undefined;
      this.newInvoice.company = {
        company_name: '',
        id: 0,
        iva_number: '',
        address: '',
        addressee_code: '',
        c_f: '',
        email_address: '',
      };
    }
    console.log('Selected Company:', this.newInvoice); // debugging
  }

  checkInvoice(): void {
    console.log('Selected Company ID:', this.newInvoice.company);
    // You might also want to store the full company object if needed
    console.log('Check company:', this.newInvoice); // debugging
  }

  onSavedProductSelected(savedProduct: SavedProductInterface): void {
    // this.newInvoice.company_id = savedProduct.id;
    // console.log('Selected Product ID:', savedProduct.id);
    // You might also want to store the full company object if needed
    this.newProductService.name = savedProduct.name;
    this.newProductService.units = savedProduct.units;
    this.newProductService.gross_amount = savedProduct.unit_price;
    this.newProductService.description = savedProduct.description;
    this.newProductService.iva_percentage = savedProduct.iva_percentage;
    // console.log('Selected Product:', savedProduct); // debugging
  }

  // onCompanyNameSelected(companyName: string) {
  //   const selectedCompany = this.companySource.data.find(
  //     // companySource?
  //     (company: { company_name: string }) =>
  //       company.company_name === companyName
  //   );

  //   if (selectedCompany) {
  //     this.newInvoice.company_id = selectedCompany.id;
  //     console.log('Selected company ID:', selectedCompany.id);
  //   }
  // }

  onPaToggleChange(event: MatSlideToggleChange) {
    if (event.checked) {
      // If "Pubblica Amministrazione" is checked
      this.newInvoice.iva_collectability = 'SPLIT';
      this.newInvoice.transmission_format = 'FPA12';
    } else {
      // If unchecked
      this.newInvoice.iva_collectability = 'IMMEDIATA';
      this.newInvoice.transmission_format = 'FPR12';
    }
  }

  onPaperInvoiceToggleChange(event: MatSlideToggleChange) {
    if (event.checked) {
      // If "Paper invoice" is checked
      this.newInvoice.paper_invoice = true;
    } else {
      // If unchecked
      this.newInvoice.paper_invoice = false;
    }
  }

  onPaidToggleChange(event: MatSlideToggleChange) {
    if (event.checked) {
      // If "Paper invoice" is checked
      this.newInvoice.is_paid = true;
    } else {
      // If unchecked
      this.newInvoice.is_paid = false;
    }
  }

  onHealthcareToggleChange(event: MatSlideToggleChange) {
    if (event.checked) {
      // If "healthcare_invoice" is checked
      this.newInvoice.healthcare_invoice = true;
    } else {
      // If unchecked
      this.newInvoice.healthcare_invoice = false;
    }
  }

  revenueStampOption: 'none' | 'customer' | 'me' = 'none';

  // private updateTotalWithRevenueStamp(): void {
  //   // Start with the base total amount
  //   this.invoice_total_amount = Number(this.total_amount);

  //   // Only add revenue stamp if it's charged to the customer
  //   if (this.revenueStampOption === 'customer') {
  //     this.invoice_total_amount += Number(this.invoice_revenue_stamp);
  //   }

  //   // If revenue stamp is on you (the business), it doesn't affect the invoice total
  //   // The cost is absorbed by the business, so the customer doesn't see it
  // }

  navigateToNewCompany() {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    // console.log(org_id);
    this.router.navigate([`/${org_id}/new_company`]);
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(NewCompanyDialog, {
      width: '7000px',
      data: {},
    });

    // Quando il dialog si chiude, se è stata creata una company la carichiamo
    // nell'autocomplete e la pre-selezioniamo automaticamente
    dialogRef.afterClosed().subscribe((createdCompany) => {
      if (createdCompany && this.companyAutocomplete) {
        this.companyAutocomplete.reload(createdCompany);
      }
    });

    this.cdr.detectChanges();
  }

  openGuide2Dialog() {
    const dialogRef = this.dialog.open(Guide2DetailsDialogComponent, {
      width: '90vw',
      maxWidth: '1000px', // Slightly wider to accommodate the link
      maxHeight: '700px',
      data: {
        organizationId: this.organization_data?.id,
        organization: this.organization_data,
      },
    });
  }

  // upload to Aruba
  generateAndUpload(invoiceId: number) {
    // this.arubaService.generateAndUploadInvoice(invoiceId).subscribe({
    //   next: (response: any) => {
    //     console.log('Success!', response);
    //     alert('Invoice processed and uploaded!');
    //     this.showSuccessMessage('Aruba works!');
    //   },
    //   error: (err: any) => {
    //     console.error('Error:', err);
    //     alert('Operation failed.');
    //   },
    // });
  }

  // Method to open PDF in dialog - receives blobUrl from service
  openPdfDialog(pdfUrl: string, invoiceId: number): void {
    const dialogRef = this.dialog.open(PdfViewerDialogComponent, {
      width: '90vw',
      maxWidth: '1200px',
      height: '90vh',
      data: {
        pdfUrl: pdfUrl,
        invoiceId: invoiceId,
      },
    });

    // Clean up blob URL when dialog closes
    dialogRef.afterClosed().subscribe(() => {
      window.URL.revokeObjectURL(pdfUrl);
    });
  }

  downloadPdf(invoiceId: number): void {
    try {
      this.invoiceService.downloadInvoicePdf(invoiceId);
      this.showSuccessMessage(
        `La fattura è stata scaricata sul dispositivo con successo!`,
      );
    } catch (error) {
      this.showErrorMessage('Errore download PDF.');
    }
  }

  // Main method to view PDF - calls service and opens dialog
  async showPdf(invoiceId: number): Promise<void> {
    try {
      const blobUrl = await this.invoiceService.showPdfInDialog(invoiceId);
      this.openPdfDialog(blobUrl, invoiceId);
    } catch (error) {
      this.showErrorMessage('Errore nel caricamento del PDF.');
      console.error('Error loading PDF:', error);
    }
  }

  // Convenience method for template binding
  onViewPdfClick(invoiceId: number): void {
    this.showPdf(invoiceId);
  }

  backToTable(): void {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/invoices_table`]);
  }

  goToDrafts(): void {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/drafts_table`]);
  }

  formatCardAmount(
    amount: number | undefined,
    currency: string = 'EUR',
  ): string {
    // Handle undefined or null values
    if (amount == null) {
      return new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(0);
    }

    const formatted = new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);

    return formatted;
  }

  formatFormDate(controlName: string): string {
    const dateValue = this.newInvoice.emission_date;
    if (!dateValue) return '';

    // If it's already a string in dd/MM/yyyy format, return as is
    if (typeof dateValue === 'string' && dateValue.includes('/')) {
      return dateValue;
    }

    // Format the date
    const date = new Date(dateValue);
    if (isNaN(date.getTime())) return '';

    return date.toLocaleDateString('it-IT'); // dd/MM/yyyy
  }

  backToDashboard(): void {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/dashboard`]);
  }

  private resetForm(form?: NgForm) {
    if (form) {
      form.resetForm();
    }
    ((this.newInvoice = {
      invoice_name: '',
      amount: 0,
      organization_id: 1,
      // company: this.companies[0], // {company_name:'default', id:1}
      company_id: 1,
    }),
      console.log('reset'));
  }

  private showSuccessMessage(message: string): void {
    this.snackBar.open(message, 'Chiudi', {
      duration: 3000,
      panelClass: ['success-snackbar'],
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  private showErrorMessage(message: string): void {
    this.snackBar.open(message, 'Chiudi', {
      duration: 3000,
      panelClass: ['error-snackbar'],
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }
}
